module.exports = __webpack_public_path__ + "img/注册页logo.fbf909e3.png";